import * as dom from 'OK/utils/dom';
import * as logger from 'OK/logger';
import throttle from 'OK/utils/throttle';

const CLICK_EVENT = 'click';
const RESIZE_EVENT = 'resize';
const CSS_CLASS_INVISIBLE = 'invisible';
const CSS_CLASS_EXPANDED = 'anon-main-design21_promo-banner_expanded';
const RESIZE_SCAN_DELAY_MILLIS = 1000;

type OnResizeFunction = () => void;
type ExpandCollapseCause = 'click' | 'resize';

interface NewUserOpData {
    type: string;
    location: string;
    context: string;
    targets: string[];
}

export default class RegistrationDesign21 {

    private activatedElement!: HTMLElement;
    private promoId!: string;
    private goToLoginButton!: HTMLElement;
    private expandBannerButton!: HTMLElement;
    private landingBlock!: HTMLElement;
    private loginBlock!: HTMLElement;
    private promoBannerBlock!: HTMLElement;
    private promoActionButton!: HTMLElement;
    private linkPixel!: string;//Пиксель для трекинга клика
    private bannerAutoExpandHeight!: number;
    private previousExpandedByResizeState: boolean | null = null;

    activate(element: HTMLElement) {
        this.activatedElement = element;

        this.promoId = element.getAttribute('data-promo-id')!;

        this.goToLoginButton = dom.firstByClass(element, 'js-go-to-login-form')!;
        this.landingBlock = dom.firstByClass(element, 'js-tab-landing')!;
        this.loginBlock = dom.firstByClass(element, 'js-tab-login-form')!;

        this.promoBannerBlock = dom.firstByClass(element, 'js-promo-banner')!;
        this.expandBannerButton = dom.firstByClass(element, 'js-expand-or-collapse-button')!;

        this.goToLoginButton.addEventListener(CLICK_EVENT, this.onClickLoginButton);
        this.expandBannerButton?.addEventListener(CLICK_EVENT, this.onClickExpandBannerButton);

        this.promoActionButton = dom.firstByClass(element, 'js-promo-action-button')!;
        this.linkPixel = element.getAttribute('data-promo-link-pixel')!;
        this.promoActionButton?.addEventListener(CLICK_EVENT, this.onClickPromoActionButton);

        this.bannerAutoExpandHeight = Number(element.getAttribute('data-banner-auto-expand-height'));
        if (this.bannerAutoExpandHeight) {
            window.addEventListener(RESIZE_EVENT, this.onResizeThrottled);
            this.onResize();
        }

        this.loadPromoImage();
    }

    deactivate() {
        this.goToLoginButton.removeEventListener(CLICK_EVENT, this.onClickLoginButton);
        this.expandBannerButton?.removeEventListener(CLICK_EVENT, this.onClickExpandBannerButton);
        this.promoActionButton?.removeEventListener(CLICK_EVENT, this.onClickPromoActionButton);
        window.removeEventListener(RESIZE_EVENT, this.onResizeThrottled);
    }

    private onClickLoginButton = () => {
        this.landingBlock.classList.toggle(CSS_CLASS_INVISIBLE, true);
        this.loginBlock.classList.toggle(CSS_CLASS_INVISIBLE, false);
    };

    private onClickPromoActionButton = () => {
        if (this.linkPixel && this.linkPixel.length !== 0 && this.linkPixel !== 'null') {
            const img = new Image();
            img.src = this.linkPixel;
        }
    };

    private onClickExpandBannerButton = () => {
        const expand = !this.isBannerExpandedByCss();
        this.expandBannerByCss(expand);
        this.logBannerState(expand, 'click');
    };

    private expandBannerByCss(expand: boolean) {
        this.promoBannerBlock.classList.toggle(CSS_CLASS_EXPANDED, expand);
    }

    private isBannerExpandedByCss() {
        return this.promoBannerBlock.classList.contains(CSS_CLASS_EXPANDED);
    }

    private loadPromoImage() {
        let promoBannerImageOriginalBlock: HTMLElement = dom.firstByClass(this.activatedElement, 'anon-main-design21_promo-banner-image-original')!;

        if (promoBannerImageOriginalBlock) {
            let imageUrl = this.activatedElement.getAttribute('data-banner-image-url')!;

            let image = new Image();
            image.onload = () => {
                if (promoBannerImageOriginalBlock) {
                    promoBannerImageOriginalBlock.style.backgroundImage = `url(${imageUrl})`;
                    promoBannerImageOriginalBlock.classList.toggle('anon-main-design21_promo-banner-image_invisible', false);
                }
            };
            image.src = imageUrl;
        }
    }

    private onResizeThrottled: OnResizeFunction = throttle(RESIZE_SCAN_DELAY_MILLIS, this.onResize.bind(this));

    private onResize() {
        if (this.bannerAutoExpandHeight) {
            let expandedByResize = window.innerHeight >= this.bannerAutoExpandHeight;
            if (this.previousExpandedByResizeState !== expandedByResize) {
                this.previousExpandedByResizeState = expandedByResize;
                this.logBannerState(expandedByResize, 'resize');
            }
        }
    }

    private logBannerState(expand: boolean, cause: ExpandCollapseCause) {
        let action = expand ? 'expand' : 'collapse';

        let newUserOp: NewUserOpData = {
            type: 'RENDER',
            location: 'home.landing_block.promo',
            context: this.promoId,
            targets: [action, cause]
        };

        logger.success('newUserOp', JSON.stringify(newUserOp));
    }
}
